import * as React from 'react';

function ListSkeleton() {
    return (
        <>
            <h2 className="order-list__skeleton-row-heading" />
            <div className="order-list__skeleton-row" />
            <div className="order-list__skeleton-row" />
            <div className="order-list__skeleton-row" />

            <h2 className="order-list__skeleton-row-heading" />
            <div className="order-list__skeleton-row" />
            <div className="order-list__skeleton-row" />
            <div className="order-list__skeleton-row" />
        </>
    );
}

export default ListSkeleton;
